import React, { useMemo } from 'react'
import './GettingStarted.css'
import RichTextContent, { CmsText } from '../../../RichTextContent/RichTextContent'
import CountUp from 'react-countup'
import { useInView } from 'react-intersection-observer'
import { useAboutSection } from '../../../../context/AboutPageContext'
import { getStatsFromSection } from '../../../../services/contentApi'
import { resolveMediaUrl } from '../../../../utils/resolveMediaUrl'
import { stripRichText } from '../../../../utils/richText'

const Stat = ({ end, suffix, label }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  })

  return (
    <div className="gs-stat" ref={ref}>
      <h3 className="gs-number">
        {inView && <CountUp end={end} duration={2.5} />}
        {stripRichText(suffix)}
      </h3>
      <RichTextContent content={label} as="p" />
    </div>
  )
}

const GettingStarted = () => {
  const { section, loading } = useAboutSection('getting-started')

  const imageSrc = useMemo(() => {
    const url = section?.media?.primary?.url
    return url ? resolveMediaUrl(url) : ''
  }, [section])

  if (loading || !section?.fields) return null

  const fields = section.fields
  const stats = getStatsFromSection(section)

  return (
    <section className="getting-started">
      <div className="getting-started-container">
        <div className="gs-left">
          {imageSrc ? <img src={imageSrc} alt="" /> : null}
        </div>

        <div className="gs-right">
          {fields.subtitle ? (
            <CmsText
              content={fields.subtitle}
              as="p"
              className="gs-subtitle"
            />
          ) : null}

          {fields.title ? (
            <CmsText content={fields.title} as="h2" className="gs-title" />
          ) : null}

          <div className="gs-stats">
            {stats.map((stat, i) => (
              <Stat
                key={i}
                end={stat.end}
                suffix={stat.suffix}
                label={stat.label}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default GettingStarted
